import React from 'react';
import type { CarrierEligibility } from '../../../../../../../api/quotes.api';
import CarrierEligibilityRow from './CarrierEligibilityRow';

interface CarrierEligibilityListProps {
  readonly options: CarrierEligibility[];
  readonly selectedValue: string;
  readonly onSelect: (treatyId: string) => void;
  readonly dark: boolean;
}

/**
 * The carrier eligibility dropdown body (FPX-7027): a labelled list of carrier
 * rows, each with its status and an expandable rule breakdown. Framework-neutral
 * so both the Mantine (excess) and MUI (standard) shells render the same panel;
 * the surrounding surface — border, shadow, background — comes from the shell.
 *
 * The row list is height-capped and scrolls internally so expanding a row grows
 * within the panel instead of pushing the whole popover past the viewport (which
 * made the Mantine menu flip upward and the MUI popover spill off-screen).
 */
const CarrierEligibilityList = ({
  options,
  selectedValue,
  onSelect,
  dark,
}: CarrierEligibilityListProps) => (
  <div
    style={{
      width: 320,
      maxWidth: '100%',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'min(60vh, 440px)',
    }}
  >
    <p
      style={{
        flexShrink: 0,
        margin: 0,
        padding: '2px 8px 6px',
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        opacity: 0.5,
      }}
    >
      Select carrier
    </p>
    <ul
      style={{
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        overflowY: 'auto',
      }}
    >
      {options.map((option) => (
        <CarrierEligibilityRow
          key={option.treatyId}
          option={option}
          selected={option.treatyId === selectedValue}
          onSelect={onSelect}
          dark={dark}
        />
      ))}
    </ul>
  </div>
);

export default CarrierEligibilityList;
